import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useOrder, usePeople } from "../Hooks/index";
import { ToDateJalali } from "../../../../Web/Common/Function";
import OthersPepole from "../Components/OthersPepole";
import { Spinner } from "react-bootstrap";
import ClassInfo from "../Components/OrderComponents/ClassInfo";
import Userinfo from "../Components/OrderComponents/Userinfo";
import { Helmet } from "react-helmet";
function ClassOrder() {
  const { classData, user } = useSelector(state => state);
  const {
    showList,
    setShowList,
    loading,
    setLoading,
    offer,
    setOffer,
    offercheck,
    sendData,
    type_payment,
    settype_payment,
  } = useOrder();
  const userDetails = [
    {
      label: "نام و نام خانوادگی",
      id: "fullname",
      placeholder: "نام و نام خانوادگی همراه",
    },
    {
      label: " شماره همراه",
      id: "mobile",
      placeholder: "71 ******* 09",
    },
    {
      label: "کد ملی",
      id: "nationalcode",
      placeholder: "396 ***** 105",
    },
    {
      label: "ایمیل",
      id: "email",
      placeholder: "excampel@gmail.com",
    },
  ];
  return (
    <>
      <Helmet>
        <title>نیکوتن | {classData.name} </title>
        <meta name="description" content={classData.name} />
        <link rel="canonical" href={window.origin + `/Classes/ClassOrder`} />
      </Helmet>
      <div className="container classorderlast mt-5">
        <div className="row justify-content-between">
          <div className="col-md-8">
            <div className="d-flex flex-column">
              <ClassInfo classData={classData} />
              <div className="row detailsclass mt-3">
                <Userinfo user={user} userDetails={userDetails} />
                <OthersPepole
                  showList={showList}
                  userDetails={userDetails}
                  offer={offer}
                  setOffer={setOffer}
                  setShowList={setShowList}
                />
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="d-flex justify-content-center">
              <Result
                showList={showList}
                loading={loading}
                setLoading={setLoading}
                offer={offer}
                setOffer={setOffer}
                offercheck={offercheck}
                sendData={sendData}
                type_payment={type_payment}
                settype_payment={settype_payment}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default ClassOrder;
const Result = ({
  showList,
  loading,
  setLoading,
  offer,
  setOffer,
  offercheck,
  sendData,
  type_payment,
  settype_payment,
}) => {
  const { classData, user_type } = useSelector(state => state);
  const Handler = () => {
    if (
      offer.code != "" &&
      offer.code != null &&
      offer.result != null &&
      offer.sendcode == true
    ) {
      setLoading({
        ...loading,
        order: true,
      });
      sendData({
        class_id: classData.id,
        otherpeopel: showList,
        offer_code: offer.code,
        type_payment,
      });
    } else {
      setLoading({
        ...loading,
        order: true,
      });
      sendData({
        class_id: classData.id,
        otherpeopel: showList,
        type_payment,
      });
    }
  };
  const typePay = [
    {
      label: "آنلاين",
      id: "gateway",
    },
    {
      label: "کیف پول",
      id: "wallet",
    },
  ];
  return (
    <>
      <div
        className="detailsclass p-3 mt-3"
        style={{
          minWidth: "250px",
        }}
      >
        <div className="d-flex flex-column ">
          <div className="d-flex justify-content-between ordrclassbuy ">
            <span>هزینه ی ثبت نام هر نفر:</span>
            <span>
              {classData.price.second_price
                ? classData.price.second_price
                : classData.price.price}
            </span>
          </div>
          <div className="d-flex justify-content-between ordrclassbuy mt-1">
            <span>تعداد همراه:</span>
            <span>{showList.length} نفر</span>
          </div>
          <hr />
          <div className="d-flex justify-content-between ordrclassbuy">
            <span>جمع:</span>
            <span>
              {(showList.length + 1) *
                (classData.price.second_price
                  ? classData.price.second_price
                  : classData.price.price)}
            </span>
          </div>
          {offer && offer.result && (
            <>
              <div className="d-flex justify-content-between ordrclassbuy mt-2">
                <span>میزان تخفیف :</span>
                <span>{offer.result.new_discount}</span>
              </div>
              <div className="d-flex justify-content-between ordrclassbuy mt-3">
                <h6>قابل پرداخت :</h6>
                <h6>{offer.result.new_total_price}</h6>
              </div>
            </>
          )}
          {user_type && (
            <div className="d-flex justify-content-evenly align-items-center mt-2">
              <div>
                <input
                  placeholder="کد تخفیف"
                  className="border p-2"
                  onChange={e => {
                    setOffer({
                      result: null,
                      sendcode: false,
                      code: e.target.value,
                    });
                  }}
                />
              </div>
              <div>
                <button
                  className="btn bg-danger "
                  style={{ color: "#ffffff" }}
                  onClick={() => {
                    setLoading({
                      ...loading,
                      offer: true,
                    });
                    offercheck({
                      offer_code: offer.code,
                      class_id: classData.id,
                      others_peopel_count: showList.length,
                    });
                  }}
                  disabled={
                    offer.code != null && offer.code != "" ? false : true
                  }
                >
                  {loading.offer ? (
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  ) : (
                    "اعمال"
                  )}
                </button>
              </div>
            </div>
          )}
          <hr />
          <div>
            <span style={{ fontSize: "15px" }}>نوع پرداخت :</span>
          </div>
          <div className="mt-2">
            <div className="btns special-btn-input d-flex flex-wrap justify-content-center aling-items-center">
              {typePay &&
                typePay.map((element, coutn) => (
                  <button
                    key={coutn}
                    className="btn  btn-red"
                    style={{
                      fontSize: "0.95rem",
                      marginLeft: "0.9rem",
                      backgroundColor: element.id != type_payment && "#EAE9E9",
                    }}
                    onClick={() => {
                      settype_payment(element.id);
                    }}
                  >
                    {element.label}
                  </button>
                ))}
            </div>
          </div>
          <div className="d-flex justify-content-center align-items-center mt-2">
            {user_type ? (
              <button
                href
                className="d-inline-block py-2  btn btn-red rounded-5 mb-2"
                style={{ width: "100%" }}
                onClick={() => {
                  Handler();
                }}
              >
                {loading.order ? "در حال پردازش" : "ثبت و پرداخت"}
              </button>
            ) : (
              <button
                href
                className="d-inline-block py-2  btn btn-red rounded-5 mb-2"
                style={{ width: "100%" }}
                disabled={true}
              >
                ثبت و پرداخت
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
